import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';  
import { Navigate, Outlet, useLocation, useOutlet, useSearchParams } from 'react-router-dom';  
  
import { LocaleContext, LoginContext, OverlayContext, ScrollContext, StateContext } from './common/App';
import { ConsumerContext } from '.';
import { DeactivateAccountPopup, LoadButton, PopupFixed, SquareButton } from './common/Common';
import "./CustomerRoute.css";
import { logout, logoutConsumer, resetLoginStatesConsumer } from "./common/util";
import { LoadState } from './common/enums';
import { useNavigateSmart } from './common/hooks';

export const CustomerRoute = () => {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);
    const state = useContext(StateContext);
    const consumer = useContext(ConsumerContext);
    const overlay = useContext(OverlayContext);
    const scroll = useContext(ScrollContext);

    const [loadState, setLoadState] = useState(LoadState.NONE);

    const navigate = useNavigateSmart();
    const location = useLocation();

    const loggedInRef = useRef(false);


    // FUNCTIONS:

    function handleLogoutClick() {
        try {
            logoutConsumer(state, login, consumer).then((response) => {
                setLoadState(LoadState.LOAD_SUCCESS);
                navigate("/");
                scroll.scrollToPlain(0, 0);
            }).catch((error) => {
                console.log(error);
                setLoadState(LoadState.LOAD_ERROR);
            });

            // Calling setLoadState() after logoutConsumer() as it could throw an exception
            setLoadState(LoadState.LOADING);
		}
		catch(e) {
			console.log(e);
		}
    }


    // EFFECTS:

    useLayoutEffect(() => {
        if(consumer.declined) {
            overlay.setOverlaySolid(true);
        }

        return () => {
            overlay.setOverlaySolid(false);
        };
    }, [consumer.declined]);

    useLayoutEffect(() => {
        loggedInRef.current = login.loggedIn;
    }, [login.loggedIn]);

    useLayoutEffect(() => {
        if(!loggedInRef.current) {
            return;
        }

        const searchParams = new URLSearchParams(location.search);

        // Get the value of the query parameter you're interested in  
        const tab = searchParams.get("unsubscribe");


        if(tab !== null) {
            consumer.setDeleteAccountDisplayed(true);
            navigate(location.pathname);
        }
    }, [location.pathname, location.search]);

    useLayoutEffect(() => {
        if(consumer.deleteAccountDisplayed) {
            // This needs to be done in the next render cycle as the overlay will be set to false by other popups
            overlay.setOverlay(true);
        }
    }, [consumer.deleteAccountDisplayed]);


    // RENDER:

    return (
        <div className="customer_route">
            <PopupFixed helpDisplayed={consumer.declined && !consumer.deleteAccountDisplayed}
                    content={
                        <div className="declined_box side_padding">
                            <div className="head">
                                {locale.msgs.WE_ARE_SORRY}
                            </div>
                            
                            <div className="text_2" dangerouslySetInnerHTML={{__html: locale.msgs.WE_ARE_SORRY_DESCR}}></div>

                            <div className="declined_logout_btn_box">
                                <LoadButton clickable={true} small={true} white={false} text={locale.msgs.LOGOUT}
                                        onClick={handleLogoutClick} saving={loadState === LoadState.LOADING}
                                        notSaved={loadState === LoadState.LOAD_ERROR}
                                        errText={locale.msgs.ERROR} />
                            </div>
                        </div>
                    }
            />

            <DeactivateAccountPopup confirmDisplayed={consumer.deleteAccountDisplayed} setConfirmDisplayed={consumer.setDeleteAccountDisplayed}
                    userActive={true}
                    onAccountDeactivated={() => {
                        resetLoginStatesConsumer(login, consumer);
                    }}

                    /* onAccountReactivated={() => {
                        setUser({...user, active: true});
                    }}
                    */
            />

            <Outlet />
        </div>
    );
};

export default CustomerRoute
